export const RELEASE_ID = import.meta.env.VITE_RELEASE_HASH ?? 'dev';
